type ChallengeCoverInput = {
  id?: number | string | null;
  eventImageUrl?: string | null;
  eventId?: string | null;
  challengeName?: string | null;
  groupName?: string | null;
  challengeType?: string | null;
};

type EventCoverInput = {
  id?: string | null;
  title?: string | null;
  imageUrl?: string | null;
};

function normalizeText(value?: string | null) {
  return String(value || "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, " ");
}

function possibleEventIds(input?: ChallengeCoverInput | null) {
  const explicitEventId = String(input?.eventId || "").trim();
  const numericId = Number(input?.id);
  const ids = [
    explicitEventId,
    Number.isFinite(numericId) ? `ev_t_${numericId}` : "",
    Number.isFinite(numericId) ? String(numericId) : "",
    Number.isFinite(numericId) ? `challenge_${numericId}` : "",
    Number.isFinite(numericId) ? `challenge-${numericId}` : "",
    Number.isFinite(numericId) ? `desafio_${numericId}` : "",
    Number.isFinite(numericId) ? `desafio-${numericId}` : "",
    Number.isFinite(numericId) ? `tournament_${numericId}` : "",
    Number.isFinite(numericId) ? `tournament-${numericId}` : "",
    Number.isFinite(numericId) ? `torneio_${numericId}` : "",
    Number.isFinite(numericId) ? `torneio-${numericId}` : "",
  ];
  return new Set(ids.map((id) => id.trim()).filter(Boolean));
}

export function resolveChallengeCoverImage(
  input?: ChallengeCoverInput | null,
  events?: EventCoverInput[],
) {
  const imageUrl = String(input?.eventImageUrl || "").trim();
  if (imageUrl) return imageUrl;

  const linkedEventIds = possibleEventIds(input);
  const title = normalizeText(input?.challengeName || input?.groupName);
  const eventMatch = (events || []).find((event) => {
    const eventImageUrl = String(event?.imageUrl || "").trim();
    if (!eventImageUrl) return false;
    const eventId = String(event?.id || "").trim();
    if (eventId && linkedEventIds.has(eventId)) return true;
    return Boolean(title) && normalizeText(event?.title) === title;
  });

  return String(eventMatch?.imageUrl || "").trim();
}
